<template>
  <v-row align="center">
    <v-dialog v-model="bandEdit" persistent max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">{{$t('common.form.add')}}</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $tc("page.raceEdit.edit-record") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" style="padding: 0 2rem">
                <v-select
                  :items="[
                    'Skiing',
                    'Ice hockey',
                    'Soccer',
                    'Basketball',
                    'Hockey',
                    'Reading',
                    'Writing',
                    'Coding',
                    'Basejump',
                  ]"
                  :label="$tc('page.raceEdit.registered-participants')"
                ></v-select>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.firstName"
                  :label="`${$tc('page.raceEdit.first-name')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.lastName"
                  :label="`${$tc('page.raceEdit.last-name')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.number"
                  :label="`${$tc('page.raceEdit.displayed-number')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-select
                  v-model="inputs.selectedClass"
                  :items="raceClasses"
                  :label="`${$tc('page.raceEdit.class')}*`"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.brand"
                  :label="`${$tc('page.raceEdit.brand')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.country"
                  :label="`${$tc('page.raceEdit.country')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.sponsors"
                  :label="`${$tc('page.raceEdit.sponsors')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-text-field
                  v-model="inputs.number"
                  :label="`${$tc('page.raceEdit.number')}*`"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding: 0 2rem">
                <v-select
                  v-model="inputs.standing"
                  :items="standingOptions"
                  :label="`${$tc('page.raceEdit.dsq-dnf')}*`"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <small>*{{ $t('common.required_form') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" dark small @click="bandEdit = false">{{$t('common.close')}}</v-btn>
          <v-btn color="darken-1" dark small @click="bandEdit = false">{{$t('common.save')}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-col class="d-flex" cols="12" sm="12">
      <v-card style="width: 100%">
        <v-alert
          outlined
          v-if="recordsTotal == 0"
          color="blue-grey"
          class="part-center"
        >
          <div>{{ message }}</div>
        </v-alert>
        <VueTabulator
          ref="tabulator"
          v-if="recordsTotal > 0"
          v-model="tabulatorData"
          :options="tabulatorOptions"
          class="table-striped table-bordered table-sm"
          style="width: 100%"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import axios from "axios";
import Action from "./Action";

export default {
  mixins: [apiCalls],
  extends: {
    Action: Action,
  },
  components: {},
  data() {
    return {
      bandDelete: false,
      bandEdit: false,
      inputs: {},
      draw: "",
      recordsFiltered: 0,
      recordsTotal: 0,
      tabulatorData: [],
      raceClasses: [],
      participantItems: [],
    };
  },
  computed: {
    message() { return this.$t("page.raceEdit.empty-participants"); },
    tabulatorOptions() {
      return {
        tooltips: true,
        addRowPos: "top",
        height: "415px",
        layout: "fitColumns",
        resizableColumns: false,
        initialSort: [
          {
            column: "no",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.raceEdit.tabulator.edit-scores"),
            field: "score",
            align: "center",
            formatter: function () {
              return `<a><i class="far fa-clock"></i></a>`;
            },
          },
          {
            title: this.$t("page.raceEdit.tabulator.first-name"),
            field: "firstName",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceEdit.tabulator.last-name"),
            field: "lastName",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceEdit.tabulator.no"),
            field: "no",
            sorter: "alphanum",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceEdit.tabulator.class"),
            field: "class",
            sorter: "alphanum",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceEdit.tabulator.brand"),
            field: "brand",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
          },
          {
            title: this.$t("page.raceEdit.tabulator.country"),
            field: "country",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
          },
          {
            title: this.$t("page.raceEdit.tabulator.sponsors"),
            field: "sponsors",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
          },
          {
            title: this.$t("page.raceEdit.tabulator.tag-id"),
            field: "tag_id",
            sorter: "alphanum",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            width: 200,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceEdit.tabulator.dsq-dnf"),
            field: "dsq_dnf",
            sorter: "string",
            sorterParams: {
              alignEmptyValues: "bottom",
            },
            formatter: function (cell) {
              return cell.getValue() != "Scored" ? cell.getValue() : "";
            },
          },
          {
            title: "", //this.$t("page.raceEdit.tabulator.edit"),
            field: "actions",
            align: "center",
            formatter: function () {
              return "<i class='fa fa-edit'></i>";
            }.bind(this),
            width: 40,
            hozAlign: "center",
            cellClick: function (e, cell) {
              this.openEdit();
              const data = cell.getRow().getData();

              this.inputs.firstName = data.firstName;
              this.inputs.lastName = data.lastName;
              this.inputs.number = data.no;
              this.inputs.brand = data.brand;
              this.inputs.country = data.country;
              this.inputs.sponsors = data.sponsors;
              this.inputs.selectedClass = data.classId;
              this.inputs.standing = data.standing;
            }.bind(this),
          },
          {
            title: "", //this.$t("page.raceEdit.tabulator.delete"),
            field: "actions",
            align: "center",
            formatter: function () {
              //plain text value
              return "<i class='fa fa-trash'></i>";
            }.bind(this),
            width: 40,
            hozAlign: "center",
            cellClick: function (e, cell) {
              const data = cell.getRow().getData();
              const participantId = data.participantId;
              this.deleteParticipant(participantId);
            }.bind(this),
          },
        ]
      };
    },
    standingOptions() {
      return [
        { text: this.$t('common.scored'), value: "Scored" },
        { text: this.$t('common.dsq'), value: "DSQ" },
        { text: this.$t('common.dns'), value: "DNS" },
        { text: this.$t('common.dnf'), value: "DNF" },
        { text: this.$t('common.ssa'), value: "SSA" },
      ];
    }
  },
  methods: {
    openEdit() {
      this.bandEdit = true;
    },
    async getRaceClasses() {
      const response = await this.api(
        "get",
        `/api/v1/promoter/race/getRaceClasses/${this.$route.params.id}`
      );

      this.raceClasses = [];
      response.message.forEach(
        function (e) {
          this.raceClasses.push({
            value: e.raceClassesId,
            text: e.name,
          });
        }.bind(this)
      );
    },
    async deleteParticipant(participantId) {
      const response = await this.api(
        "delete",
        `/api/v1/promoter/race/${this.$route.params.id}/participant/${participantId}`
      );
      if (response) {
        this.loadData();
      }
    },

    async loadData() {
      this.tabulatorData = [];

      axios
        .get(
          `${this.root}/laravel/public/api/v1/promoter/race/loadParticipants/${this.$route.params.id}`
        )
        .then((response) => {
          const {
            data: {
              message: { data, draw, recordsFiltered, recordsTotal },
            },
          } = response;
          const _data = data.map((elem) => {
            return {
              participantId: elem.id,
              score: "",
              firstName: elem.fName,
              lastName: elem.lName,
              no: elem.displayedNumber,
              class: elem.className,
              classId: elem.classId,
              brand: elem.brand,
              country: elem.country,
              sponsors: elem.sponsors,
              tag_id: elem.num,
              standing: elem.standing,
              actions: elem.id,
            };
          });

          this.tabulatorData = _data;
          this.recordsTotal =
            typeof recordsTotal != "undefined" ? recordsTotal : 0;
          this.draw = draw;
          this.recordsFiltered = recordsFiltered;
        }).catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );

      this.getRaceClasses();
    },
  },
  created() {},
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.tabulator {
  font-size: 14px !important;
}

.cust-column {
  font-size: 11px !important;
}

.part-center {
  width: 80%;
  margin: 2rem auto;
}
</style>
